import type { ResumeAnalysisResponse } from "./find-analysis";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

export const generateResumeAnalysis = async (data: { id: string }) => {
  const response = await axios.post<ResumeAnalysisResponse>(`/resume-analysis/${data.id}/generate`);
  return response.data;
};

export const useGenerateResumeAnalysis = () => {
  const queryClient = useQueryClient();

  const {
    error,
    isPending: loading,
    mutateAsync: generateAnalysisFn,
  } = useMutation({
    mutationFn: generateResumeAnalysis,
    onSuccess: (data) => {
      queryClient.setQueryData(["resume-analysis", { id: data.resumeId }], data);
    },
  });

  return { generateAnalysis: generateAnalysisFn, loading, error };
};
